import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../core/authentication/authentication.service';

import { PageEnum } from '../models/page-enum.model';
import { FloatActionButtonEnum } from '../models/float-action-button-enum.model';
import { ActionsEnum } from '../models/action-enum.model';

@Injectable()
export class FloaterButtonsService {

    constructor(
        private authService: AuthenticationService
    ) {
    }

    /**
   * Método responsável por incluir a função respectiva do tipo do botão enviado por parâmetro.
   * @param buttonsList Lista de botões que contém o botão que deseja alterar a function.
   * @param buttonType FloatActionButtonEnum com o tipo do botão que deseja incluir a function.
   * @param functionToSet Função com o método que deseja chamar no botão.
   */
    public setFunctionToFloaterButton(buttonsList: any[], buttonType: FloatActionButtonEnum, functionToSet: (any) => any): any[] {
        if (buttonsList) {
            const button = buttonsList.find(x => x.id === buttonType);
            const index = buttonsList.indexOf(button);

            // Caso encontre o botão, ajusta as functions
            if (button) {
                button.onClick = functionToSet;
                buttonsList[index] = button;
            }

            return buttonsList;
        }
    }

    /**
     * Método responsável por retornar o array de butons baseados no pageMode.
     * @param pageMode PageEnum atual.
     * @param cancelFunction Função com o método chamado no caso de click no botão voltar.
     * @param idPermissao Id da permissão que irá visualizar o botão. (Opcional)
     * @param idAcao Id da ação que irá efetuar. (Opcional)
     * @param actionsList Lista de ações para validar se irá exibir ou não o botão de editar. (Opcional)
     * @param showFormularioButton Booleano indicando se o botão de Formulários será exibido. (Opcional)
     */
    public createFloaterButtons(pageMode: PageEnum, cancelFunction: (any) => any, idPermissao = null, idAcao = null, actionsList = null, showFormularioButton = false): any[] {
        const arr = [
            {
                id: FloatActionButtonEnum.Voltar,
                iconClass: 'fa fa-undo',
                label: 'Voltar',
                onClick: cancelFunction
            }
        ];

        if (showFormularioButton) {
            arr.push({
                id: FloatActionButtonEnum.Formularios,
                iconClass: 'fa fa-file',
                label: 'Formulários',
                onClick: () => {
                }
            });
        }

        this.authService.IdentityPermissionAction.subscribe(permissaoAcao => {
            switch (pageMode) {
                case PageEnum.Visualizando:
                    if ((actionsList && actionsList.some(x => x === ActionsEnum.Editar) || ((idPermissao === null && idAcao === null && actionsList === null) || (this.hasPermissionAction(idPermissao, idAcao, permissaoAcao))))) {
                        arr.push({
                            id: FloatActionButtonEnum.Editar,
                            iconClass: 'fa fa-edit',
                            label: 'Editar',
                            onClick: () => {
                            }
                        });
                    }
                    break;
                default:
                    if (idPermissao && idAcao && this.hasPermissionAction(idPermissao, idAcao, permissaoAcao)) {
                        arr.push({
                            id: FloatActionButtonEnum.Salvar,
                            iconClass: 'fa fa-save',
                            label: 'Salvar',
                            onClick: () => {
                            }
                        });
                    }
                    break;
            }
        });

        return arr;
    }

    /**
     * Verifica se o usuário tem o conjunto PermissaoAcao para acessar o conteúdo.
     * @param idPermissao ID da permissão que o usuário precisa ter para acessar o conteúdo.
     * @param idAcao ID da ação que o usuário precisa ter para acessar o conteúdo.
     */
    public hasPermissionAction(idPermissao, idAcao, PermissaoAcao: any[]): boolean {
        return PermissaoAcao.some(x => x.Permissao.IdPermissao === idPermissao && (idAcao === 0 || x.Acao.IdAcao === idAcao));
    }
}
